import { truncateText } from "@jti/fe-common";
import { Tooltip } from "@jti/ui/components/Tooltip";
import { useTranslations } from "@jti/ui/providers/useTranslations";

import { ConsumablesSectionTitle } from "../ConsumablesFormSectionTitle";

import styles from "../../ConsumablesForm.module.scss";

const MAX_TOOLTIP_LENGTH = 130;

type ConsumablesStrengthSelectorSectionTitleProps = {
  step: number;
};

export const ConsumablesStrengthSelectorSectionTitle = ({ step }: ConsumablesStrengthSelectorSectionTitleProps) => {
  const { __ } = useTranslations();

  const tooltipText = __("consumablesForm.step.strength_selector.tooltip");

  return (
    <ConsumablesSectionTitle translationKey="consumablesForm.step.strength_selector.title" stepCount={step}>
      <div className={styles.consumablesPurchaseTypeSectionTitleTooltipWrapper}>
        <Tooltip content={<span>{truncateText(tooltipText, MAX_TOOLTIP_LENGTH)}</span>} size="small" />
      </div>
    </ConsumablesSectionTitle>
  );
};
